import React, {useContext} from 'react';
import {Button, Form, Input} from "antd";
import UserLoginContext from "../../../context/userLoginContext";
import {useNavigate} from 'react-router-dom';
import '../../../styles/component/user/reset-password.scss'
import {toast} from "react-toastify";
import server from "../../../server";
import {SafetyOutlined} from "@ant-design/icons";

function ResetPassword() {
    const {user} = useContext(UserLoginContext);
    const [form] = Form.useForm();
    const navigate = useNavigate()

    const onFinish = async (e: any) => {
        try {
            const payload = {
                currentPassword: e.currentPassword,
                newPassword: e.newPassword,
                confirmPassword: e.confirmPassword,
            }
            await server.user.changePassword(payload, user?.id || "");
            form.resetFields();
            localStorage.removeItem("token");
            toast.success("Password Updated!")
            navigate("/login")
        } catch (e) {

        }
    }

    const passwordRules = [
        "Minimum 8 characters",
        "Atleast 1 uppercase",
        "Atleast 1 lowercase",
        "Atleast 1 number",
        "Atleast 1 special character"
    ]

    const firstName = user?.name?.firstName;
    const middleName = user?.name?.middleName;
    const lastName = user?.name?.lastName;

    return (
        <div className={'change-password-container'}>
            <h1 className={'change-password-title'}>Change password </h1>
            <p className={'change-password-subTitle'}>Manage your password and keep your account safe</p>
            <div className={'change-password-card'}>
                <div className={'change-password-card-left'}>
                    <SafetyOutlined className={'safety-icon'}/>
                    <div className={'left-title'}>
                        Secure Your Account
                    </div>
                    <div className={'left-desc'}>
                        Create a strong password to protect your HRMS account and personal data.
                    </div>
                    <ul className={"change-password-validation-list"}>
                        {passwordRules.map((rule) => (
                            <li key={rule} className={'change-password-validation-item'}>
                                <span className={"change-password-validation-dot"}/>
                                {rule}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={'change-password-card-right'}>
                    <div className={'change-password-form-title'}>
                        Change Password
                    </div>
                    <div className={'change-password-form-subtitle'}>
                        Hello {firstName} {middleName} {lastName} — enter your new password below
                    </div>
                    <Form
                        form={form}
                        name="basic"
                        className={"reset-password-form"}
                        onFinish={onFinish}
                        autoComplete="off"
                        layout="vertical"
                    >
                        <Form.Item
                            label="Current Password"
                            name="currentPassword"
                            rules={[
                                {required: true, message: 'Please Enter your current password!'},
                            ]}
                        >
                            <Input.Password/>
                        </Form.Item>
                        <Form.Item
                            label="New Password"
                            name="newPassword"
                            rules={[
                                {
                                    pattern: new RegExp("^(?=.*\\d)(?=.*[a-zA-Z])(?=.*[A-Z])(?=.*[-\\#\\$\\@\\!\\.\\%\\&\\*])(?=.*[a-zA-Z]).{8,16}$"),
                                    message: "new password must contain at least 8 character 1 uppercase 1 lowercase 1 number and 1 special character"
                                },
                                {required: true, message: 'Please Enter your new password!'},

                            ]}
                        >
                            <Input.Password/>
                        </Form.Item>
                        <Form.Item
                            label="Confirm Password"
                            name="confirmPassword"
                            rules={[
                                {required: true, message: 'Please Enter Confirm confirm password!'},
                                {
                                    pattern: new RegExp("^(?=.*\\d)(?=.*[a-zA-Z])(?=.*[A-Z])(?=.*[-\\#\\$\\@\\!\\.\\%\\&\\*])(?=.*[a-zA-Z]).{8,16}$"),
                                    message: "confirm password must contain at least 8 character 1 uppercase 1 lowercase 1 number and 1 special character"
                                },
                            ]}
                        >
                            <Input.Password/>
                        </Form.Item>
                        <Form.Item wrapperCol={{offset: 8, span: 16}}>
                            <Button type="primary" htmlType="submit">
                                Update Password
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword;